import React from 'react';
import './style.scss';
import useCream from '../../../../contexts/cream';
import Loader from '../../../general/loader';
import clsx from 'clsx';
import {
  API_CreamTransaction,
  CreamTransactionTypes,
  TransactionStatuses
} from 'shared';
import { formatDate, minifyHash } from '../../../../utils/utils';

const CreamShopTransactions = () => {
  const { txHistory, txHistoryLoading, updatePendingLoading } = useCream();

  if (txHistoryLoading) {
    return <Loader size={50} />;
  }

  if (txHistory.length === 0) return null;

  return (
    <div className='creamshop-txs'>
      <h4 className='creamshop-txs-header body-2'>Transaction History</h4>
      <ul className='creamshop-txs-tx-wrapper'>
        {txHistory.map((tx, index) => (
          <Transaction data={tx} key={index} updating={updatePendingLoading} />
        ))}
        {updatePendingLoading && (
          <Loader size={70} useAbsoluteWrapper color='invalid' />
        )}
      </ul>
    </div>
  );
};

interface PendingProps {
  data: API_CreamTransaction;
  updating: boolean;
}

const Transaction = ({ data, updating }: PendingProps) => {
  return (
    <li className={clsx('creamshop-txs-tx', updating && 'updating')}>
      <PendingTxType type={data.type} />
      <Spr />
      <span>{data.creamAmount} $CREAM</span>
      <Spr />
      <span>{formatDate(new Date(data.createdAt))}</span>
      <Spr />
      <span>TXHASH</span> <PendingTxHash hash={data.hash} />
      <Spr />
      <PendingTxStatus status={data.status} />
    </li>
  );
};

const Spr = () => <span>&nbsp;·&nbsp;</span>;

interface TypeProps {
  type: CreamTransactionTypes;
}

const PendingTxType = ({ type }: TypeProps) => (
  <span className={`creamshop-txs-tx-${type}`}>{type}</span>
);

const PendingTxHash = ({ hash }) => (
  <span className='creamshop-txs-tx-hash'>{minifyHash(hash)}</span>
);

interface StatusProps {
  status: TransactionStatuses;
}

const PendingTxStatus = ({ status }: StatusProps) => (
  <span className={`creamshop-txs-tx-${status}`}>{status}</span>
);

export default CreamShopTransactions;
